import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CdkDrag, CdkDragHandle, CdkDropList} from "@angular/cdk/drag-drop";
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";
import {ContextMenu, ContextMenuModule} from "primeng/contextmenu";
import {MenuItem} from "primeng/api";
import { ImageItem } from '@core/_utils/tools.utils';
import {NgClass} from "@angular/common";

@Component({
    selector: 'image',
    standalone: true,
    imports: [
        CdkDrag,
        CdkDropList,
        CheckboxModule,
        FormsModule,
        ContextMenuModule,
        CdkDragHandle,
        NgClass
    ],
    templateUrl: './image.component.html',
    styleUrl: './image.component.scss'
})
export class ImageComponent implements OnInit{
    @ViewChild('cm') cm: ContextMenu;

    @Input() public imageItem: ImageItem;
    @Output() onMenuAction = new EventEmitter<any>();
    @Input() public contextMenu: MenuItem[];

    ngOnInit() {
        this.contextMenu = this.contextMenu.map(item => ({
            ...item,
            command: (event) => {
                // Utiliser une fonction fléchée pour préserver le contexte
                this.onAction({
                    item: {
                        action: item.action
                    }
                });
            }
        }));
    }

    onContextMenu(event: MouseEvent, imageItem) {
        event.preventDefault();
        this.cm.show(event);
    }

    onAction(event) {
        this.onMenuAction.emit({action: event.item.action, image: this.imageItem});
    }
}